// React
import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

// Containers Injections
import {
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../containers/componentsInjection';

export const FixedRepetitionView = ({ validation }) => {
  return (
    <Row>
      <Col md={3}>
        <div className="mb-3">
          <Label htmlFor="periodicity" className="form-label">
            Periodicidade
          </Label>
          <SelectInput
            inputId="periodicity"
            className="form-control"
            options={[
              {
                value: 'd',
                label: 'Diário',
              },
              {
                value: 'm',
                label: 'Mensal',
              },
              {
                value: 'w',
                label: 'Semanal',
              },
              {
                value: 'y',
                label: 'Anual',
              },
            ]}
            placeholder="Selecione"
            value={validation.values.periodicity}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('periodicity', eventInput)
              );
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('periodicity', eventInput)
              );
            }}
          />
        </div>
      </Col>
      <Col md={4}>
        <div className="mb-3">
          <Label htmlFor="frequency" className="form-label">
            Repete-se a cada {validation.values.frequency.value}{' '}
            {validation.values.frequency.value > 1 ? 'meses' : 'mês'}
          </Label>
          <SelectInput
            inputId="frequency"
            className="form-control"
            options={[
              {
                value: '1',
                label: '1',
              },
              {
                value: '2',
                label: '2',
              },
              {
                value: '3',
                label: '3',
              },
              {
                value: '4',
                label: '4',
              },
            ]}
            placeholder="Selecione"
            value={validation.values.frequency}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('frequency', eventInput)
              );
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('frequency', eventInput)
              );
            }}
          />
        </div>
      </Col>
    </Row>
  );
};
